import React from 'react';
import ContentCard from 'Shared/ContentCard';
import { onView, onClick } from 'Shared/ContentCard/DataLayer';
import { translate } from 'Shared/translate';
import * as styles from './base.scss';
import ViewTracker from '../ViewObserver/ViewTracker';
const filterCards = (card) => card.appearance !== 'large';
export default ({ cards, title }) => (React.createElement("div", { className: styles.wrapper },
    title && React.createElement("div", { className: styles.h3 }, title),
    React.createElement("div", { className: styles.flexwrapper }, cards && cards.length > 0 ? (cards.filter(filterCards).map((data, i) => React.createElement(ViewTracker, { key: 'contentCardRowViewTracker' + i, onView: (e) => onView(e, data, i) },
        React.createElement(ContentCard, Object.assign({}, data, { key: i, onClick: (e) => onClick(e, data, i) }))))) : (React.createElement("div", null, translate('/Errors/NoContent'))))));
